import * as React from "react";
import {
  ContractCreatedActivity,
  isContractCreatedActivity,
  ContractTemplateCreatedActivity,
  isContractTemplateCreatedActivity,
  ContractTemplateUpdatedActivity,
  isContractTemplateUpdatedActivity,
  CampaignCreatedActivity,
  isCampaignCreatedActivity,
  CampaignUpdatedActivity,
  isCampaignUpdatedActivity,
  MadCreatedActivity,
  isMadCreatedActivity,
  MadUpdatedActivity,
  isMadUpdatedActivity,
  MadDocumentAddedActivity,
  isMadDocumentAddedActivity,
  MadDocumentDeletedActivity,
  isMadDocumentDeletedActivity,
  ReportCheckedActivity,
  isReportCheckedActivity,
  ReportFilledActivity,
  isReportFilledActivity,
  UserCreatedActivity,
  isUserCreatedActivity,
  TemplateCreatedActivity,
  isTemplateCreatedActivity,
  TemplateUpdatedActivity,
  isTemplateUpdatedActivity,
  UserUpdatedActivity,
  isUserUpdatedActivity,
  isUserDocumentAddedActivity,
  UserDocumentAddedActivity,
} from "./ActivityImpl";

import { ActivityFragment } from "../../graphql/fragments";
import { Activity as ActivityType } from "../../graphql/types/base";
import {
  CompanyUpdatedActivity,
  isCompanyUpdatedActivity,
} from "./ActivityImpl/CompanyUpdatedActivity";
import useTranslations from "../../hooks/useTranslations";
import { GroupCreatedActivity, isGroupCreatedActivity } from "./ActivityImpl/GroupCreatedActivity";
import { GroupUpdatedActivity, isGroupUpdatedActivity } from "./ActivityImpl/GroupUpdatedActivity";
import { isUserDocumentDeletedActivity, UserDocumentDeletedActivity } from "./ActivityImpl/UserDocumentDeletedActivity";

interface Props {
  activity: ActivityType;
}

export type ActivityConfig<T extends ActivityFragment> = {
  Component: React.ElementType;
  typeValidator: (q: ActivityFragment) => q is T;
};

const activityConfig: ActivityConfig<ActivityFragment>[] = [
  {
    Component: UserUpdatedActivity,
    typeValidator: isUserUpdatedActivity,
  },
  {
    Component: UserCreatedActivity,
    typeValidator: isUserCreatedActivity,
  },
  {
    Component: UserDocumentAddedActivity,
    typeValidator: isUserDocumentAddedActivity,
  },
  {
    Component: UserDocumentDeletedActivity,
    typeValidator: isUserDocumentDeletedActivity,
  },
  {
    Component: MadDocumentAddedActivity,
    typeValidator: isMadDocumentAddedActivity,
  },
  {
    Component: MadDocumentDeletedActivity,
    typeValidator: isMadDocumentDeletedActivity,
  },
  {
    Component: ReportFilledActivity,
    typeValidator: isReportFilledActivity,
  },
  {
    Component: ReportCheckedActivity,
    typeValidator: isReportCheckedActivity,
  },
  {
    Component: ContractCreatedActivity,
    typeValidator: isContractCreatedActivity,
  },
  {
    Component: MadUpdatedActivity,
    typeValidator: isMadUpdatedActivity,
  },
  {
    Component: MadCreatedActivity,
    typeValidator: isMadCreatedActivity,
  },
  {
    Component: GroupCreatedActivity,
    typeValidator: isGroupCreatedActivity,
  },
  {
    Component: GroupUpdatedActivity,
    typeValidator: isGroupUpdatedActivity,
  },
  {
    Component: CampaignUpdatedActivity,
    typeValidator: isCampaignUpdatedActivity,
  },
  {
    Component: CampaignCreatedActivity,
    typeValidator: isCampaignCreatedActivity,
  },
  {
    Component: TemplateUpdatedActivity,
    typeValidator: isTemplateUpdatedActivity,
  },
  {
    Component: TemplateCreatedActivity,
    typeValidator: isTemplateCreatedActivity,
  },
  {
    Component: ContractTemplateUpdatedActivity,
    typeValidator: isContractTemplateUpdatedActivity,
  },
  {
    Component: ContractTemplateCreatedActivity,
    typeValidator: isContractTemplateCreatedActivity,
  },
  {
    Component: CompanyUpdatedActivity,
    typeValidator: isCompanyUpdatedActivity,
  },
];

const Activity: React.FC<Props> = ({ activity }) => {
  const Config = activityConfig.find((c) => c.typeValidator(activity));
  const t = useTranslations()

  return Config ? (
    <Config.Component activity={activity} />
  ) : (
    <div>{t("appErrors.componentUnknown", {key: activity.key})}</div>
  );
};

export default Activity;
